import { Injectable, Optional } from '@angular/core';

import { EnvironmentConfig } from './environment-config';

@Injectable()
export class EnvironmentService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private _environment: any;

  constructor(@Optional() config: EnvironmentConfig) {
    this._environment = config.environment;
  }

  get environment() {
    return this._environment;
  }
}
